import { render, staticRenderFns } from "./sentence.vue?vue&type=template&id=91f564e8&scoped=true&"
import script from "./sentence.vue?vue&type=script&lang=js&"
export * from "./sentence.vue?vue&type=script&lang=js&"
import style0 from "./sentence.vue?vue&type=style&index=0&id=91f564e8&lang=less&scoped=true&"
import style1 from "./sentence.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91f564e8",
  null
  
)

component.options.__file = "sentence.vue"
export default component.exports